import type { RouteObject } from 'react-router-dom';
import U2000RequireRole from '../u2000Core/components/controls/U2000RequireRole';
import U3207, { U3207ROLES } from './U3207';
import U3207DashboardScreen from './components/U3207DashboardScreen';

const U3207Routes: RouteObject[] = [
  {
    path: 'U3207',
    element: <U2000RequireRole allowedRoles={[U3207ROLES.READ]} />,
    children: [
      {
        path: '',
        element: <U3207 />,
        children: [{ index: true, element: <U3207DashboardScreen /> }],
      },
    ],
  },
];

export default U3207Routes;
